import { useLanguage } from '../contexts/LanguageContext';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Car, Globe, Wrench, Users, Palette, Database } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Settings() {
  const { t } = useLanguage();

  const settingsCategories = [
    {
      id: 'car-brands',
      title: t('settings.brandsManagement'),
      description: t('settings.brandsDescription'),
      icon: Car,
      path: '/settings/car-brands',
      color: 'from-blue-500 to-cyan-500'
    },
    {
      id: 'car-models',
      title: t('settings.modelsManagement'),
      description: t('settings.modelsDescription'),
      icon: Wrench,
      path: '/settings/car-models',
      color: 'from-orange-500 to-red-500'
    },
    {
      id: 'sellers',
      title: t('settings.sellersManagement'),
      description: t('settings.sellersDescription'),
      icon: Users,
      path: '/settings/sellers',
      color: 'from-purple-500 to-pink-500'
    },
    {
      id: 'buyers',
      title: t('settings.buyersManagement'),
      description: t('settings.buyersDescription'),
      icon: Users,
      path: '/settings/buyers',
      color: 'from-teal-500 to-cyan-500'
    },
    {
      id: 'language',
      title: t('settings.language.title'),
      description: t('settings.language.subtitle'),
      icon: Globe,
      path: '/settings/language',
      color: 'from-green-500 to-emerald-500'
    },
    {
      id: 'invoice-theme',
      title: t('settings.invoiceTheme.title'),
      description: t('settings.invoiceTheme.subtitle'),
      icon: Palette,
      path: '/settings/invoice-theme',
      color: 'from-pink-500 to-rose-500'
    },
    {
      id: 'database-backup',
      title: t('settings.databaseBackup.title'),
      description: t('settings.databaseBackup.subtitle'),
      icon: Database,
      path: '/settings/database-backup',
      color: 'from-indigo-500 to-purple-500'
    }
  ];

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-slate-200">
        <div className="w-full px-4 sm:px-6 lg:px-8 py-6">
          <h1 className="text-2xl font-semibold text-slate-900 tracking-tight">{t('settings.title')}</h1>
          <p className="text-slate-500 text-sm mt-0.5">{t('settings.subtitle')}</p>
        </div>
      </header>

      <main className="w-full px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {settingsCategories.map((category) => {
            const Icon = category.icon;
            return (
              <Link key={category.id} to={category.path}>
                <Card className="rounded-2xl border border-slate-200 shadow-sm bg-white hover:shadow-md transition-shadow cursor-pointer">
                  <CardHeader className="text-center">
                    <div className={`w-16 h-16 mx-auto mb-4 rounded-2xl bg-gradient-to-r ${category.color} flex items-center justify-center`}>
                      <Icon className="h-8 w-8 text-white" />
                    </div>
                    <CardTitle className="text-lg font-semibold text-slate-900">{category.title}</CardTitle>
                    <CardDescription className="text-sm text-slate-500">
                      {category.description}
                    </CardDescription>
                  </CardHeader>
                  <CardContent className="text-center">
                    <Button variant="outline" className="w-full border-slate-200 text-slate-700 hover:bg-slate-50 rounded-lg text-sm font-medium">
                      {t('settings.manage')}
                    </Button>
                  </CardContent>
                </Card>
              </Link>
            );
          })}
        </div>
      </main>
    </div>
  );
}
